var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.items,"label":_vm.label,"item-text":_vm.itemText,"return-object":"","loading":_vm.attesa,"clearable":"","value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }